import { CheckIcon } from "@heroicons/react/24/solid";
import { CommunitySortOptions } from "@sp-crm/core";
import * as React from "react";
import { useContext } from "react";
import { StatelessSearchbarItemContext } from "./stateless-searchbar-item";

export const CommunitySortOptionDescriptions = {
    distance: "Distance",
    name: "Name",
    number: "Number of placements",
    recent: "Most recent placement",
    rating: "Rating",
};

interface SortCommunityProps {
    value: CommunitySortOptions;
    onChange: (newVal: CommunitySortOptions) => void;
    showDistance?: boolean;
}

export const SortCommunity: React.FC<SortCommunityProps> = props => {
    const { showDistance, value, onChange } = props;
    const closeCalloutCallback = useContext(StatelessSearchbarItemContext);
    const chooseOption = (sortOption: CommunitySortOptions) => {
        if (closeCalloutCallback) {
            closeCalloutCallback();
        }
        onChange(sortOption);
    };

    const itemData = Object.keys(CommunitySortOptionDescriptions).map(untypedKey => {
        const key = untypedKey as CommunitySortOptions;

        return {
            value: key,
            description: CommunitySortOptionDescriptions[key],
            shouldDisplay: key !== "distance" || showDistance,
        };
    });

    return (
        <div className="w-64">
            <div className="text-xs font-medium uppercase tracking-wide text-gray-500">
                Sort by
            </div>
            <ul className="mt-3 py-1">
                {itemData.map(d =>
                    d.shouldDisplay ? (
                        <li
                            key={d.value}
                            className="-mx-2 flex cursor-pointer items-center justify-between gap-3 rounded px-2 py-2 hover:bg-gray-50"
                            onClick={() => chooseOption(d.value)}>
                            <span
                                className={`text-sm ${
                                    value === d.value
                                        ? "font-semibold text-gray-900"
                                        : "text-gray-700"
                                }`}>
                                {d.description}
                            </span>
                            {value === d.value ? (
                                <CheckIcon className="h-4 w-4 flex-shrink-0 text-brand-600" />
                            ) : null}
                        </li>
                    ) : null,
                )}
            </ul>
        </div>
    );
};
